import React from 'react';
import { useTranslation } from 'react-i18next';
import { VISIT_LIMIT } from '../../view/journey';
import { SectionHead } from '../SectionHead';
import { VisitCard } from './VisitCard';

export const Journey = ({ journey, filterLabel, allVisits, onToggle, onClearFilter, onToggleAll }) => {
    const { t } = useTranslation('reportPage');

    return (
        <div
            id="timeline"
            role="group"
            aria-labelledby="timeline-title"
            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        >
            <SectionHead
                as="h3"
                id="timeline-title"
                title={t('journey.title')}
                sub={t('journey.sub', { count: journey.total })}
            />
            {journey.filtered && (
                <div className="filterbar" role="status">
                    <span>{filterLabel}</span>
                    <button
                        type="button"
                        className="textlink noprint"
                        style={{ padding: '4px 8px' }}
                        onClick={onClearFilter}
                    >
                        {t('journey.showAllVisits')}
                    </button>
                </div>
            )}
            <ol className="jr">
                {journey.items.map(visit => (
                    <li className={`jr-item${visit.hidden ? ' more' : ''}`} key={visit.key}>
                        {visit.yearHead && (
                            <div className="jr-year">
                                <span className="jr-y">{visit.y}</span>
                                <span className="jr-rule" />
                            </div>
                        )}
                        <div className="jr-row">
                            <div className="jr-km">
                                {visit.hasKm && <div className="jr-kmv">{visit.km}</div>}
                                <div className="jr-kmn">{visit.kmSide}</div>
                            </div>
                            <div className="jr-spine">
                                <div className="jr-l1" />
                                <span className={`node ${visit.node}`} />
                                <div className="jr-l2" />
                            </div>
                            <VisitCard visit={visit} onToggle={onToggle} />
                        </div>
                        {visit.gap && (
                            <div className="jr-gaprow">
                                <div className="jr-kmsp" />
                                <div className="jr-spine">
                                    <div className={`jr-gl${visit.gap.kind ? ` ${visit.gap.kind}` : ''}`} />
                                </div>
                                <div className={`jr-gap${visit.gap.kind ? ` ${visit.gap.kind}` : ''}`}>
                                    {visit.gap.label}
                                </div>
                            </div>
                        )}
                    </li>
                ))}
            </ol>
            {journey.empty && (
                <p className="muted" style={{ margin: 0 }}>
                    {t('journey.noMatch')}
                </p>
            )}
            {journey.hasMore && (
                <button
                    type="button"
                    className="textlink noprint"
                    style={{ alignSelf: 'center', marginTop: 8 }}
                    onClick={onToggleAll}
                >
                    {allVisits
                        ? t('journey.showLatest', { count: VISIT_LIMIT })
                        : t('journey.showAll', { count: journey.total })}
                </button>
            )}
        </div>
    );
};
